<template>
  <div class="service ">
    <headd :mobile_title="mobile_title"></headd>
    <!-- <div class="search container"><img class="icon" />搜索你想要看的公司</div> -->

 <div class="order_list container">
      <div class="coupon_title hidden-sm hidden-xs">服务的客户</div>
      <el-tabs v-model="activeName" @tab-click="handleClickb">
       <el-tab-pane label="全部" name="1"> </el-tab-pane>
        <el-tab-pane label="剩50天" name="2"> </el-tab-pane>
        <el-tab-pane label="剩30天" name="3"> </el-tab-pane>
        <el-tab-pane label="剩10天" name="4"> </el-tab-pane>
        <el-tab-pane label="已过期" name="5"> </el-tab-pane>
      </el-tabs>
      <div class="search-input">
        <input @input="inputChange()" v-model="searchkey" type="text" placeholder="搜索客户" />
      </div>
 </div>

    <div
      class="box_con ds container"
      v-for="(item, index) in companys"
      :key="item.id"
    >
      <div style="flex-direction: column;">
        <div class="info_data">
          <div class="data_head">
            <div class="data_title"><view class="line"></view>法务咨询服务</div>
            <div class="data_right">剩余 {{ item.leftDays }} 天</div>
          </div>
          <div class="data_cell_list mt35">
            <div class="data_cell">
              <div class="cell_title">服务期限</div>
              <div class="cell_con">{{ item.expiredAt }} 到期</div>
            </div>

            <div class="data_cell">
              <div class="cell_title">客户名称</div>
              <div class="cell_con">{{ item.uname }}</div>
            </div>
            <div class="data_cell">
              <div class="cell_title">客户电话</div>
              <div class="cell_con">{{ item.username }}</div>
            </div>
          </div>
        </div>
        <div class="btn_list">
          <div class="btnc kefu" @click="kefu(item.recipient_id)">客户沟通</div>
        </div>
      </div>
    </div>
    <div class="gomore" @click="morelist" v-show="!flag">加载更多</div>
    <foot></foot>
  </div>
</template>

<script>
import { getserviceCustomers, getkefuchannel } from "../../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "法务咨询服务",
      isChange: -1,
      current: "first",
       activeName: "1",
       tabs: ['全部','剩50天', '剩30天','剩10天','已过期'],
			orderstatus_type: ['', 'l50','l30','l10','l0'],
      banners: [
        {
          id: 1,
          img: "../../../static/user/icon_6.png"
        }
      ],
      pageindex: 1,
      flag: false,
      searchkey: "",
      companys: []
    };
  },
  components: { headd, foot },
  mounted() {
    this.getCompanys();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClickb(tab, event) {
      var index = parseInt(tab.name);
      var _self = this;
      _self.orderstatus = _self.orderstatus_type[index - 1];
      _self.companys = [];
      _self.pageindex = 1;
      _self.searchkey=this.searchkey;
      _self.flag = false;
      _self.getCompanys();
    },
    async getkefuchannel() {
      var _self = this;
      var data = { uid: localStorage.getItem("userId") };
      const res = await getkefuchannel(data);
      console.log(res);
      if (res.data.status == 1) {
        //_self.kfid = res.data.data.kfid
        return res.data.data.kfid;
      }
    },
    kefu(recipient) {
      var uid = localStorage.getItem("userId");
      var _self = this;
      var recipient_id = recipient;
      if (recipient_id == 0) {
        console.log(recipient_id);
        _self.getkefuchannel().then(function(result) {
          console.log(result);
          recipient_id = result;
          this.$router.push({
            path: "chat",
            query: {
              uid: uid,
              recipient_id: result
            }
          });
        });
      } else {
        this.$router.push({
          path: "chat",
          query: {
            uid: uid,
            recipient_id: recipient_id
          }
        });
      }
    },
    changeTab(e) {
      var _self = this;

      console.log("当前选中的项：" + e);
      _self.current = parseInt(e);
    },
    async getCompanys() {
      var _slef = this;
      var data = {
        uid: localStorage.getItem("userId"),
         orderstatus: _slef.orderstatus,
        search: _slef.searchkey,
        page: _slef.pageindex,
        limit: 15
      };
      const res = await getserviceCustomers(data);
      _slef.companys = _slef.companys.concat(res.data.data.users);
      if (res.data.data.users.length < 15) {
        _slef.flag = true;
      }
    },
    debounce(func,wait){
            if(this.timeout) clearTimeout(this.timeout)
            this.timeout = setTimeout(()=>{

                func()

            },wait)
        },

     inputChange(e){
           
            this.debounce(this.getsearch,600)
     },
    
    getsearch() {
      //console.log(value.value);
      //this.search = value.value;
      (this.companys = []),
        (this.pageindex = 1),
        (this.flag = false),
        this.getCompanys();
    },
    
    open(e) {
      var _self = this;
      var index = e.currentTarget.dataset.index;
      //console.log(index)
      if (index != _self.isChange) {
        _self.isChange = index;
      } else {
        _self.isChange = -1; //不注释则可以点击取消，注释之后点击就不再取消
      }
    },
    goView_image(url) {
      window.open(url, "_blank");
    },
    goView(urlnew) {
      let url = urlnew;
      console.log(url);
      window.open(url, "_blank");
    },
    morelist() {
      if (!this.flag) {
        this.pageindex++;
        this.getCompanys();
      }
    }
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #f2f2f2;
}
.service {
  margin: 0 auto;
  flex-direction: column;
  text-align: left;
  border-top: 0.02rem solid #f5f5f5;
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: 0.3rem auto;
    .container {
      padding: 0;
    }
  }
  .ds {
    margin-top: 0.2rem;
    border: 1px solid #c4c4cc;
    border-radius: 0.2rem;
    padding: 0.2rem 0.32rem;
    width: 8rem;
    @media (max-width: 991px) {
      width: 6.86rem;
      padding: 0.2rem 0.32rem !important;
      border-radius: 0.2rem !important;
    }
  }

.order_list {
  flex-direction: column;
  width: 8rem;
  @media (max-width: 991px) {
    width: 100%;
    margin-top: 0;
  }
  margin-top: 0.3rem;
  .coupon_title {
    font-size: 0.26rem;
    margin-bottom: 0.32rem;
    text-align: left;
  }

  .search-input {
    margin: 0 auto 0.34rem auto;
    width: 7.6rem;
    height: 0.4rem;
    @media (max-width: 991px) {
        height: 0.6rem;
        width: 100%;
      }
    background: #ffffff;
    border-radius: 0.3rem;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 0.5rem;
    display: flex;
    border: 0.01rem solid #c4c4cc;
    background: url(../../../../static/icon/searchicon.png) no-repeat;
    background-size: auto 60%;
    background-position: 0.2rem;
    input {
      width: 100%;
      height: 100%;
      font-size: 0.18rem;
      border: none;
      @media (max-width: 991px) {
        font-size: 0.26rem;
      }
      
    }

  }
}

  .search {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    height: 0.7rem;
    background: #ffffff;
    border-radius: 0.12rem;
    font-size: 0.24rem;
    border: 0.01rem solid #c4c4cc;
    color: #8d8e99;
    align-items: center;
    justify-content: center;
    line-height: 0.7rem;
    .icon {
      width: 0.24rem;
      height: 0.24rem;
    }
  }
}
.uni-searchbar {
  background-color: #f2f2f2;
}

.btn_list {
  justify-content: center;
  flex-wrap: wrap;
  display: flex;
  margin-bottom: 0rpx;
  width: 100%;
  margin-top: 0.2rem;

  .btnc {
    width: 2.7rem;
    height: 0.7rem;
    font-size: 0.24rem;
    color: #ffffff;
    line-height: 0.7rem;
    justify-content: center;
    align-items: center;
    border-radius: 0.35rem;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    @media (max-width: 991px) {
      font-size: 0.28rem;
    }
  }

  .btnc.kefu {
    background-color: #1395ff;
  }

  .btnc.buy {
    background-color: #f4556c;
  }
}
.info_data {
  flex-direction: column;
  text-align: left;
  .data_head {
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.07rem;
    padding: 0;

    .data_title {
      height: 0.33rem;
      font-size: 0.2rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.33rem;
      align-items: center;

      .line {
        width: 0.05rem;
        height: 0.26rem;
        background: #1395ff;
        border-radius: 0.03rem;
        margin-right: 0.05rem;
      }
    }

    .arrow_right {
      width: 0.3rem;
      height: 0.17rem;
      display: flex;
      align-items: center;

      img {
        width: 0.3rem;
        height: 0.17rem;
      }
    }

    .data_right {
      font-size: 0.16rem;
      color: #8d8e99;
      line-height: 0.25rem;
      display: flex;

      .right {
        margin-left: 0.1rem;
        font-size: 0.15rem;
        color: #ff545a;
      }
    }
  }

  .data_sn {
    height: 0.25rem;
    font-size: 0.18rem;
    color: #1395ff;
    line-height: 0.25rem;
    margin-top: 0.1rem;
    margin-bottom: 0rem;
    margin-left: 0.08rem;
  }

  .data_cell_list {
    flex-direction: column;

    .data_cell {
      padding: 0;
      margin-bottom: 0.16rem;

      .cell_title {
        width: 1rem;
        line-height: 0.25rem;
        height: 0.25rem;
        font-size: 0.16rem;
        color: #1b1c33;
      }

      .cell_con {
        font-size: 0.16rem;
        color: #000;
        font-weight: normal;
        line-height: 0.25rem;
      }
    }
  }

  .data_table_list {
    width: 100%;
    flex-direction: column;

    .table_head {
      height: 0.4rem;
      line-height: 0.4rem;
      font-weight: bolder;
    }

    .head_25 {
      flex: 1;
      font-size: 0.16rem;
      text-align: center;
      height: 0.4rem;
      line-height: 0.4rem;
      color: #1b1c33;
      align-items: center;
      justify-content: center;
      background-color: #f2f2f2;
      border: 0.01rem solid rgba(196, 196, 204, 0.5);
    }

    .head_50 {
      flex: 2;
      font-size: 0.16rem;
      text-align: center;
      height: 0.4rem;
      line-height: 0.4rem;
      color: #1b1c33;
      align-items: center;
      justify-content: center;
      background-color: #f2f2f2;
      border: 0.01rem solid rgba(196, 196, 204, 0.5);
      border-left: 0;
      border-right: 0;
    }
  }

  .data_img {
    width: 100%;

    .img_item {
      width: 1.4rem;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        text-align: center;
        width: 1.4rem;
        height: auto;
        vertical-align: middle;
        margin-bottom: 0.2rem;
      }

      .item_btn {
        cursor: pointer;
        width: 0.86rem;
        height: 0.32rem;
        line-height: 0.32rem;
        font-size: 0.14rem;
        text-align: center;
        color: #fff;
        justify-content: center;
        background: #1395ff;
        border-radius: 0.16rem;
      }
    }
  }

  @media (max-width: 991px) {
    flex-direction: column;

    .data_head {
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.07rem;

      .data_title {
        height: 0.4rem;
        font-size: 0.28rem;

        font-weight: bolder;
        color: #1b1c33;
        line-height: 0.4rem;
        align-items: center;

        .line {
          width: 0.05rem;
          height: 0.26rem;
          background: #1395ff;
          border-radius: 0.03rem;
          margin-right: 0.05rem;
        }
      }

      .arrow_right {
        width: 0.3rem;
        height: 0.17rem;

        img {
          width: 0.3rem;
          height: 0.17rem;
        }
      }

      .data_right {
        font-size: 0.26rem;

        color: #8d8e99;
        line-height: 0.3rem;

        .right {
          margin-left: 0.1rem;
          font-size: 0.28rem;
          color: #ff545a;
        }
      }
    }

    .data_sn {
      height: 0.3rem;
      font-size: 0.26rem;

      color: #1395ff;
      line-height: 0.3rem;
      margin-top: 0.1rem;
      margin-bottom: 0.2rem;
      margin-left: 0.08rem;
    }

    .data_cell_list {
      flex-direction: column;

      .data_cell {
        padding: 0rpx;
        margin-bottom: 0.2rem;

        .cell_title {
          width: 1.66rem;
          line-height: 0.33rem;
          height: 0.33rem;
          font-size: 0.26rem;

          color: #1b1c33;
        }

        .cell_con {
          width: 4.5rem;
          font-size: 0.26rem;

          color: #1b1c33;
          line-height: 0.33rem;
        }
      }
    }

    .data_table_list {
      width: 6.38rem;
      flex-direction: column;

      .table_head {
        height: 0.77rem;
        line-height: 0.77rem;
        font-weight: 600;
      }

      .head_25 {
        flex: 1;
        font-size: 0.26rem;
        text-align: center;
        height: 0.77rem;
        line-height: 0.77rem;
        color: #1b1c33;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        border: 1rpx solid rgba(196, 196, 204, 0.5);
      }

      .head_50 {
        flex: 2;
        font-size: 0.26rem;
        text-align: center;
        height: 0.77rem;
        line-height: 0.77rem;
        color: #1b1c33;
        align-items: center;
        justify-content: center;
        background-color: #f2f2f2;
        border: 0.01rem solid rgba(196, 196, 204, 0.5);
        border-left: 0;
        border-right: 0;
      }
    }

    .data_img {
      width: 100%;

      .img_item {
        width: 2.4rem;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          text-align: center;
          width: 2.4rem;
          height: 2.4rem;
          vertical-align: middle;
          margin-bottom: 0.2rem;
        }

        .item_btn {
          width: 1.26rem;
          height: 0.4rem;
          line-height: 0.4rem;
          font-size: 0.24rem;
          text-align: center;
          color: #fff;
          justify-content: center;
          background: #1395ff;
          border-radius: 0.2rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/fwzm/fwzm.vue